module.exports = __webpack_public_path__ + "assets/img/2ed3346906f08e01bf9138faa79d5f0e.png";